import React from 'react'
import AnalyticWeb from '../assets/img/analytics.webp'
import { Button } from 'bootstrap'

const HomeBody = () => {
  return (
    <>
        <section className='home-hero bg-light pt-md-5 pb-md-5'>
            <div className='container pt-md-4 pb-md-5'>
                <div className='row py-5'>
                    <div className='col-md-6 col-sm-12 mb-2 mt-2 px-5 d-flex flex-column justify-content-center'>
                        <div className='col-12 mb-4'>
                            <h1 className='font-dm -seconday mb-4'>Manage Your<br/>Organization Better</h1>
                            <p style={{textAlign: "justify"}}>Elevate Your Business, Unleash Success Your all-in-one business management solution, combining ticketing and project management for seamless operations and growth.</p>
                        </div>
                        <div className='col-12 text-center'>
                            <button className='btn btn-lg btn-dark border-radius-none px-5 py-3 mb-3 w-100'>Let's Connect</button>
                            <button className='btn btn-lg btn-outline-dark border-radius-none px-5 py-3 w-100'>Get Started Free</button>
                        </div>
                    </div>
                    <div className='col-md-6 col-sm-12 mb-2 px-5 d-flex align-items-center'>
                        <img src={AnalyticWeb} height="auto" width="100%"/>
                    </div>
                </div>
            </div>
        </section>  
        <section className='bg-dark pt-5 pb-5' id="our-services">
            <div className='container'>
                <h1 className='font-dm mb-5 text-center text-light'>Software Developed Using</h1>
                <div className='row'>
                    <div className='col-md-3 col-sm-12 mb-3'>
                        <div className='card bg-light border-radius-none h-100'>
                            <div className='card-body'>
                                <h5 className='mt-3 text-center'>Frontend</h5>
                                <p className='text-center'>React, Next, HTML, CSS, JavaScript, jQuery, etc,..</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-3 col-sm-12 mb-3'>
                        <div className='card bg-light border-radius-none h-100'>
                            <div className='card-body'>
                                <h5 className='mt-3 text-center'>Backend</h5>
                                <p className='text-center'>Java, Spring Boot, Struts, Micro Services, etc,..</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-3 col-sm-12 mb-3'>
                        <div className='card bg-light border-radius-none h-100'>
                            <div className='card-body'>
                                <h5 className='mt-3 text-center'>Database</h5>
                                <p className='text-center'>MySQL, PostgreSQl, MangoDB, Firebase, etc,..</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-3 col-sm-12 mb-3'>
                        <div className='card bg-light border-radius-none h-100'>
                            <div className='card-body'>
                                <h5 className='mt-3 text-center'>Server</h5>
                                <p className='text-center'>Ubuntu, Linux, Debian, Microsoft, etc,..</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className='bg-light pt-5 pb-5' id="about-devcraft">
            <div className='container'>
                <h1 className='font-dm mb-5 text-center'>About DevCraft</h1>
                <div className='bg-dark'>
                    <div className='row pt-3'>
                        <div className='col-md-6 col-sm-12 mb-3 px-5 d-flex align-items-center'>
                            <img src={AnalyticWeb} height="auto" width="100%"/>
                        </div>
                        <div className='col-md-6 col-sm-12'>
                            <p className='text-light px-5 py-5 text-justify'>
                                Devcraft is a cutting-edge software development company at the forefront of innovation and technology. With a passion for crafting exceptional solutions, they have earned a reputation for delivering world-class software products and services. Their team of highly skilled and motivated developers, designers, and engineers work collaboratively to create bespoke software solutions that cater to the unique needs of their diverse clientele. Devcraft's commitment to staying ahead of the curve enables them to utilize the latest technologies and methodologies, ensuring that their software products are not only efficient and scalable but also future-proof. As a result, Devcraft has become a trusted partner for businesses seeking transformational digital solutions to streamline processes, optimize performance, and unlock their full potential in the ever-evolving digital landscape.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default HomeBody